import { createPortal } from 'react-dom';

import NotificationBell from '@/components/notification-bell';
import IdentityMenu from './identity-menu';
import { isDesktopApp } from './desktop-updates';

/**
 * Desktop app only: the bell + account live in the native tab strip, but their real components (which
 * poll, beacon data to the strip, and own the flyouts) must stay mounted on EVERY page — including the
 * ones with no app header (boards index, whiteboards/canvas). So we mount them once, app-wide, hidden and
 * portaled to <body> (no transformed ancestor), pulled just under the strip so a strip click opens the
 * flyout right there. Renders nothing in a browser.
 */
export default function DesktopHeaderProxy() {
  if (!isDesktopApp() || typeof document === 'undefined') return null;
  return createPortal(
    <div className="pointer-events-none fixed right-3 top-[-36px] z-[60] flex items-center gap-1 opacity-0" aria-hidden>
      <NotificationBell />
      <IdentityMenu />
    </div>,
    document.body,
  );
}
